import config from './dashboardDara.json';


export const getToken = () => {
  return localStorage.getItem(config.token);
};

export const setToken = (token) => {
  localStorage.setItem(config.token, token);
};

export const removeToken = () => {
  localStorage.removeItem(config.token);
};
